import { FoodModel } from './diet-food-model';
export class RecipeCategoryModel {
  constructor(
    public name: string,
    public _id: string,
    public recipes: RecipeModel[]
  ) {}
}

export class RecipeModel {
  constructor(
    public food: string,
    public image: string,
    public imagePath: string,
    public _id: string,
    public free: boolean
  ) {}
}

export class RecipeDetailModel {
  constructor(
    public bookmark: boolean,
    public description: string,
    public difficulty: string,
    public food: FoodModel,
    public image: string,
    public imagePath: string,
    public _id: string,
    public likes: number,
    public free: boolean,
    public ingredients: RecipeIngredientModel[],
    public instructions: RecipeInstructionModel[],
    public serving: number,
    public time: number,
    public weight: number,
    public video?: string
  ) {}
}

export class RecipeIngredientModel {
  constructor(
    public amount: number,
    public cooked: string,
    public food: RecipeIngredientFoodModel,
    public unit: RecipeIngredientUnitModel,
    public _id: string,
    public unitDescription: string,
    public description: string,
    public kitchenInventory: boolean,
    public mainUnit?: RecipeIngredientUnitModel
  ) {}
}

export class RecipeIngredientFoodModel {
  constructor(public name: string, public _id: string) {}
}

export class RecipeIngredientUnitModel {
  constructor(public name: string, public _id: string) {}
}

export class RecipeInstructionModel {
  constructor(
    public text: string,
    public _id: string,
    public end: number,
    public start: number
  ) {}
}

export class BookmarkModel {
  constructor(public user: string, public recipe: BookmarkRecipeModel) {}
}

export class BookmarkRecipeModel {
  constructor(
    public food: BookmarkFoodModel,
    public image: string,
    public imagePath: string,
    public _id: string,
    public free: boolean
  ) {}
}

export class BookmarkFoodModel {
  constructor(public name: string) {}
}
